<template>
    <div ref="content">
        <div class="menu_top padding_bottom_64">
            <div class="cart_suggesttitle">个人资料</div>
            <div class="person_info display_flex">
                <div class="textalign_center" style="padding-top:24px;box-sizing:border-box;">
                    <div class="headImage" :style="{backgroundImage:'url('+ personInfo.image +')'}">
                        <input  name="file" id="upload-file" class="uploadFile" type="file"  @change="uploadImage()"  />
                        <div class="headimagecover">修改头像</div>
                    </div>
                    <div class="changeImgtip">点击图片更改头像</div>
                </div>
                <div class="infocontain">
                    <div class="info_detail">
                        <div class="margin_bottom_20">
                            <span class="info_left">名称</span>
                            <input type="" name="" class="infoInput" v-model="personInfo.nickname">
                        </div>
                        <div class="margin_bottom_20">
                            <span class="info_left">性别</span>
                            <div style="display: inline-block;">
                                <div style="display: inline-block;vertical-align: middle;">
                                    <span :class="['sexname',personInfo.sex== '1'?'active':'']" @click="choosesex('1')">男</span>
                                </div>
                                <div style="display: inline-block;margin-left: 28px;vertical-align: middle;">
                                    <span :class="['sexname',personInfo.sex== '2'?'active':'']" @click="choosesex('2')">女</span>
                                </div>
                                <!-- <input id="nan" name="sex" type="radio" value="1" :checked="personInfo.sex== '1'" v-bind:class="['inforadio',{active: personInfo.sex== '1'}]">
                                </input>
                                <label for="nan">男</label> -->
                            </div>
                            <!-- <div style="display: inline-block;margin-left:28px;">
                                <input id="nv" name="sex" type="radio" value="2" :checked="personInfo.sex== '2'" v-bind:class="['inforadio',{active: personInfo.sex== '2'}]">
                                </input>
                                <label for="nv">女</label>
                            </div> -->
                        </div>
                        <div class="margin_bottom_20">
                            <span class="info_left">手机</span>
                            <input type="" name="" class="infoInput" v-model="personInfo.mobile">
                        </div>
                        <div class="margin_bottom_20">
                            <span class="info_left">地址</span>
                            <textarea type="" name="" class="infoarea" v-model="personInfo.address"></textarea>
                        </div>
                        <div class="savebtn" @click="save">保存资料</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

input {
    background: none;
    outline: none;
    border: none;
}

input:focus {
    border: none;
}

::-webkit-input-placeholder {
    color: #999;
}

::-moz-placeholder {
    color: #999;
}

:-ms-input-placeholder {
    color: #999;
}

:-moz-placeholder {
    color: #999;
}

input,
button,
select,
textarea {
    outline: none;
    padding: 6px;
    box-sizing: border-box;
}

textarea {
    resize: none
}

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}


// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding: 32px 0;
    box-sizing: border-box;

    .lookall {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #262633;
        padding-right: 12px;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;

        &:after {
            content: '';
            position: absolute;
            right: 0;
            top: 13px;
            width: 6px;
            height: 6px;
            border-top: 1px solid #262633;
            border-right: 1px solid #262633;
            transform: rotate(45deg);

        }
    }
}

.padding_left_394 {
    padding-left: 394px;
    box-sizing: border-box;
}

.padding_left_430 {
    padding-left: 430px;
    box-sizing: border-box;
}

.padding_left_72 {
    padding-left: 72px;
    box-sizing: border-box;
}

.padding_left_24 {
    padding-left: 24px;
    box-sizing: border-box;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.padding_left_70 {
    padding-left: 70px;
    box-sizing: border-box;
}

.padding_left_32 {
    padding-left: 32px;
    box-sizing: border-box;
}

.margin_top_32 {
    margin-top: 32px;
}

.padding_top_32 {
    padding-top: 32px;
    box-sizing: border-box;
}

.padding_left_280 {
    padding-left: 280px;
    box-sizing: border-box;
}

.padding_left_162 {
    padding-left: 162px;
    box-sizing: border-box;
}

.padding_left_366 {
    padding-left: 366px;
    box-sizing: border-box;
}

.margin_top_40 {
    margin-top: 40px;
    box-sizing: border-box;
}

.margin_bottom_32 {
    margin-bottom: 32px;
}

.padding_right_16 {
    padding-right: 16px;
    box-sizing: border-box;
}

.padding_right_28 {
    padding-right: 28px;
    box-sizing: border-box;
}

.icon_round {
    width: 24px;
    height: 24px;
    border: 1px solid #D5D5D7;
    border-radius: 50%;
}

.cartbox {
    height: 64px;
    line-height: 64px;
    background: #F8FBFD;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    text-align: left;

    .totalprice {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        margin-left: 30px;
    }

    .paybtn {
        width: 180px;
        height: 100%;
        line-height: 64px;
        background: #60DEB4;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        margin-left: 40px;
        vertical-align: top;
    }
}

.cartlist {

    .cartlist_Item {
        margin-top: 24px;

    }

    .person_cartlist_Item_R {
        width: 100%;
        background: #FFFFFF;
        border: 1px solid #F4F4F5;
        padding: 24px 0 24px 24px;
        box-sizing: border-box;

        .person_order_Each {
            padding-bottom: 24px;
            box-sizing: border-box;
        }

        .roundType {
            width: 72px;
            height: 72px;
            line-height: 72px;
            color: #fff;
            border-radius: 50%;
            background-color: #60DEB4;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
        }

        .carttitle {
            width: 385px;
            margin-right: 80px;
            margin-left: 24px;
            text-align: left;

            .title {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #262633;
                line-height: 36px;
                @include linelimt(1);
            }

            .desc {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #888888;
                line-height: 24px;
                @include linelimt(1);
                margin-top: 4px;
            }
        }

        .price {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF7467;
            padding-left: 60px;
            box-sizing: border-box;
        }

        .delbtn {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
        }
    }
}

// 个人中心
.person_info {
    width: 100%;
    height: 380px;
    position: relative;
    background: #F8FBFD;
    padding: 40px 0 0 50px;
    box-sizing: border-box;
    background-image: url('http://p1.fishqc.net/FtyuiXUysk7VQcKJFco9gLbFm5ly');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    .headImage {
        width: 80px;
        height: 80px;
        line-height:80px;
        color: #fff;
        border-radius: 50%;
        border: 2px solid #fff;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        margin: 0 auto;
        cursor: pointer;
        font-size: 14px;
        box-sizing: border-box;
        position: relative;
        &:hover{
            .headimagecover{
                display: block;
            }
        }

        .uploadFile{
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 999;
            cursor:pointer;
        }

    }

    .headimagecover{
        width:100%;
        height: 100%;
        position: absolute;
        left:0;
        top:0;
        background-color:rgba(0,0,0,.45);
        border-radius:50%;
        display: none;
    }

    .changeImgtip {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A8A8AD;
        line-height: 28px;
    }

    .edit_btn {
        width: 144px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        border: 1px solid #60DEB4;
        position: absolute;
        right: 32px;
        top: 32px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #60DEB4;
        cursor: pointer;

    }

    .infocontain {
        position: absolute;
        left: 200px;
    }

    .margin_bottom_20 {
        margin-bottom: 20px;
    }

    .info_detail {
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;

        .nickname {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #51515C;
            line-height: 28px;
            padding-bottom: 10px;
            box-sizing: border-box;
        }

        .info_left {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A8A8AD;
            line-height: 28px;
            padding-right: 16px;
            box-sizing: border-box;
        }

        .info_right {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 28px;
        }

        .infoInput {
            width: 180px;
            height: 32px;
            background: #FFFFFF;
            border: 1px solid #F4F4F5;
        }

        .infoarea {
            width: 416px;
            height: 83px;
            background: #FFFFFF;
            border: 1px solid #F4F4F5;
            line-height: 22px;
            vertical-align: top;
        }

        .inforadio {
            width: 24px;
            height: 24px;
            background-image: url('http://p1.fishqc.net/FqXqfoCJ-iPzFMFb4YDkq7XorVAW');
            background-image: url('http://p1.fishqc.net/FgLfRefZT_XS3oJZDITRSLQ7dsOH');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
            vertical-align: middle;
            margin-right: 6px;
            // &.active{
            //     background-image: url('http://p1.fishqc.net/FgLfRefZT_XS3oJZDITRSLQ7dsOH');
            // }
        }
    }
}

.person_order_box {
    height: 40px;
    line-height: 40px;
    background: #F8FBFD;
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
}

.savebtn {
    width: 144px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #60DEB4;
    border-radius: 18px;

    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-left: 46px;
    display: inline-block;
    cursor: pointer;

}
.sexname{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    padding-left: 30px;
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    &:before{
        position: absolute;
        content: '';
        width: 24px;
        height: 24px;
        background: url('https://p1.fishqc.net/FqXqfoCJ-iPzFMFb4YDkq7XorVAW');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        left: 0;

    }
    &.active{
        &:before{
        position: absolute;
        content: '';
        width: 24px;
        height: 24px;
        background: url('https://p1.fishqc.net/FgLfRefZT_XS3oJZDITRSLQ7dsOH');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        left: 0;

    }
}   
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
import { personinfoApi,editUserInfoapi} from '@/api/api.js'
export default {
    name: '',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            HeadImghover: false,
            personInfo:{
                image:'',
                sex:0
            },
            uploadForm: {
                p:'https://saleapi.fishqc.com/Ucenter/uploadAvatar',
            },
        }
    },
    computed: {
       
    },
    watch:{
        'personInfo':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        }
    },
    mounted() {
        
        this.personinfofun()
    },
    methods: {
        tapchoose(item) {
            this.currenttap = item
        },
        changeHeadimg(type) {
            console.log(type)
            if (type == 'show') {
                
                this.HeadImghover = true
            } else {
               
                this.HeadImghover = false
            }
        },
        personinfofun(){
            personinfoApi({}).then(res => {

                if (res.code == 200) {
                    this.personInfo = res.data
                }else if(res.code == 401){

                }else {
                    // this.toast(res.message)
                    
                }
            })

        },
        save(){
            editUserInfoapi({
                nickname:this.personInfo.nickname,
                address:this.personInfo.address,
                sex:this.personInfo.sex,
                phone:this.personInfo.phone,
                occupation:this.personInfo.address,
                birthday:'',
            }).then(res => {
                if (res.code == 200) {
                    // this.personInfo = res.data
                    this.toast('保存成功！')
                }else if(res.code == 401){

                }else if(res.code == 500){
                    this.toast('保存成功！')
                }else {
                    this.toast(res.message)
                    
                }
            })
        },
        uploadImage:function(){
            var files = document.getElementById("upload-file").files;
            if (files.length > 1) {
                this.toast('一次只能上传一张图片');
                return;
            }

            var that = this;
            this.myFile = files[0];


            if (this.myFile.size > 2097152) {
                this.toast('请选择小于2M的截图上传,建议手机截图后再上传');
                return;
            }

            if (this.myFile.type.indexOf("image") == -1) {
                this.toast('只允许上传图片');
                return;
            }

            var r = new FileReader();
            r.readAsDataURL(this.myFile);

            r.onload = function() {
                // vm.imageUrl = this.result;
            }

            // if (this.personInfo.image == "./images/pic_ico.png") {
            //     this.toast('请选择图片');
            //     return;
            // }

            var form = new FormData();
            var xhr = new XMLHttpRequest();
            form.append('Content-Type', this.myFile.type || 'application/octet-stream');
            form.append('avatar', this.myFile);
            xhr.open('POST', this.uploadForm.p, true);
            xhr.withCredentials = true;
            xhr.send(form);
            that.toast('正在上传，请稍等！');
            xhr.onreadystatechange = function() {
                if (xhr.readyState >= 4) {
                    if (xhr.responseText == '') {
                        setTimeout(function() {
                            that.toast('上传失败，请重新上传！');
                            
                            return;

                        },1000);

                    }
                    
                    var res = JSON.parse(xhr.responseText);
                   

                    if (res.code == '200') {
                        that.toast('上传成功！');
                        that.personInfo.image = res.data.image;

                    } else {
                    }

                }else{
                   
                }
            }
        },
        choosesex(sex){
            this.personInfo.sex = sex
        }
    }
}
</script>